// Shared "After Submit" navigation resolver used by AddFormV1/EditFormV1.
// Admin-configured per FormGroup (group.afterSubmit — see FormGroupsSection.jsx),
// generic across every module/project: no module name is ever referenced here.

// Picks the configured behavior from the group with the lowest `order` that
// declares one. Returns null when no group configures it, so callers fall
// back to their existing (pre-feature) navigation — unchanged behavior.
export function resolveAfterSubmit(groups) {
  const withConfig = (groups ?? [])
    .filter((g) => g?.afterSubmit?.mode)
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
  return withConfig[0]?.afterSubmit ?? null;
}

// Resolves a configured route template (e.g. "/trainers/:id") against the
// created/updated record id and the submitted field values, and rejects
// anything that isn't a safe in-app path (blocks open-redirect / javascript:
// / data: payloads an admin could otherwise paste into the target field).
export function safeNavTarget(template, recordId, values) {
  const raw = String(template ?? '').trim();
  if (!raw || !raw.startsWith('/') || raw.startsWith('//')) return null;
  if (/^[a-z][a-z0-9+.-]*:/i.test(raw)) return null; // any "scheme:" prefix, e.g. javascript:, data:
  return raw.replace(/:([A-Za-z_][\w]*)/g, (_, key) => {
    const value = key === 'id' ? recordId : values?.[key];
    return encodeURIComponent(value ?? '');
  });
}
